export interface IDesktopAppProps {
  appName: string;
  appIcon: string;
  appId: string;
}

export enum AppNamesEnum {
  Internet = "Internet",
  Email = "E-mail",
  MyDocuments = "My Documents",
  MyRecentDocuments = "My Recent Doc...",
  MyPictures = "My Pictures",
  MyMusic = "My Music",
  MyComputer = "My Computer",
  ControlPanel = "Control Panel",
  Printers = "Printers",
  HelpAndSupport = "Help and Support",
  Search = "Search",
  Run = "Run",
  Minesweeper = "Minesweeper",
  Portfolio = "Portfolio",
}
